import Relay from 'react-relay';

export default class RunFlowTestsMutation extends Relay.Mutation {
    getMutation() {
        return Relay.QL`mutation {runFlowTests}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on RunFlowTestsPayload {
                job {
                    id
                    realId
                    organisation_id
                    status
                    progress
                }
                success
                error
                errors {
                    field
                    message
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            flowId: this.props.flowId,
            flowDefId: this.props.flowDefId,
            executeWrites: this.props.executeWrites,
        };
    }
}
